import { render } from "./StatCardSkeleton.vue?vue&type=template&id=7f4d9c2b"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__